<app-breadcrumb></app-breadcrumb>
<mat-card class="cardWithShadow">
    <mat-card-content class="p-20 cardWithShadow">
        <div class="row justify-content-between gap-16">
            <div class="col-lg-4">
                <mat-form-field appearance="outline" class="w-100 hide-hint ">
                    <input matInput
                        placeholder="{{ 'LABEL.SEARCH_LABEL' | translate }} {{ 'ENTITY.CATEGORY' | translate }}"
                        [formControl]="searchCategory" />
                    <mat-icon matSuffix>
                        <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
                    </mat-icon>
                </mat-form-field>
            </div>
            <div class="col-lg-4 d-flex align-items-center justify-content-end">
                <button mat-flat-button color="primary" class="cardWithShadow" (click)="onAddCategory()">
                    <mat-icon>add</mat-icon>
                    {{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.CATEGORY' | translate }}
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>
<mat-card class="cardWithShadow m-0">
    <mat-card-content class="p-24">
        <div class="table-responsive table-scroll-container">
            <table mat-table [dataSource]="dataSource" class="w-100">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'ENTITY.CATEGORY' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">

                        <p class="f-w-600 mat-subtitle-1 f-s-16 m-t-0 ellipsis-text">
                            <a [routerLink]="['/clinical/category', element.id,'clinicalsubcategory']"
                                class="categorylink">{{element.name}}</a>
                        </p>

                    </td>
                </ng-container>

                <ng-container matColumnDef="categorytype">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.CATEGORY_TYPE' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">{{ element.categoryTypeId }}</td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'LABEL.DESCRIPTION_LABEL' |
                        translate }}</th>
                    <td mat-cell *matCellDef="let element" class="f-s-14 ellipsis-text"
                        [matTooltip]="element.description">
                        {{ element.description }}
                    </td>
                </ng-container>



                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.ACTION_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="action-link">
                        <a class="m-r-10 cursor-pointer" (click)="onClinicalCategoryEdit(element)">
                            <i-tabler name="edit" class="icon-18"></i-tabler>
                        </a>
                        <a class="m-r-10 cursor-pointer" (click)="onClinicalCategoryDelete(element.id)">
                            <i-tabler name="trash" class="icon-18"></i-tabler>
                        </a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'ENTITY.CLINICALITEM' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="action-link">
                        <p class="f-w-600 mat-subtitle-1 f-s-16 m-t-0">
                            <a (click)="onGoClinicalItem(element.id)" class="iconlink cursor-pointer"
                                matTooltip="ClinicalItem"><i-tabler name="external-link" class="icon-18"></i-tabler></a>
                        </p>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <div *ngIf="dataSource.data.length === 0" class="no-data-message">
                <p class="text-center f-s-20 f-w-700 m-t-20">{{'LABEL.NO_DATA' | translate}}</p>
            </div>
            <mat-paginator class="paginator-fixed" [ngClass]="{'pointer-events-none': isLoading}"
                [length]="pagination.rowCount" [pageSize]="pagination.pageSize" [pageSizeOptions]="pageSizeOptions"
                [showFirstLastButtons]="true" [pageIndex]="pagination.currentPage">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>